module.exports = {"title":"Search Events","searchLabel":"Keyword","searchBtn":"Search"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchEvents/locales/en.json
// module id = 1454
// module chunks = 0